import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import Videojs from "../video-js";
import { Text, Image as JssImage } from "@sitecore-jss/sitecore-jss-react";
import { mobileIs, loadScrollMagic, getOverallSettingsClasses } from "../../utils/siteUtils";

import "./style.scss";
const SingleVideo = props => {
  const { video, poster, heading, m_video, m_poster, playIcon } = props.fields;
  const autoplay = props.params.autoplay === '1';
  const videoEl = useRef(null);
  const isMobile = mobileIs();
  const [isPlaying, setIsPlaying] = React.useState(false);
  const playBtnNode = useRef(null);
  const [showIcon, setShowIcon] = useState(false)
  const [iconPosition, setIconPosition] = useState({
    top: '43vh',
    left: '75.3vw'
  });
  const rootEl = useRef(null);
  const autoPlayTimer = useRef(null);
  const hasPlayedPreview = useRef(false);

  let videoOptions =
    (video && video.value)
      ? {
        sources: [
          {
            src: video.value.src,
            type: video.value.mimeType
          }
        ],
        poster: poster ? poster.value.src : null,
        videoTitle: '',
        autoplay: autoplay,
        controls: autoplay == true ? false : true,
        muted: true,
        loop: true
      } : null;
  let videoOptionsMobile =
    (m_video && m_video.value)
      ? {
        sources: [
          {
            src: m_video.value.src,
            type: m_video.value.mimeType
          }
        ],
        poster: m_poster ? m_poster.value.src : null,
        videoTitle: '',
        autoplay: autoplay,
        controls: autoplay == true ? false : true,
        muted: true,
        loop: true
      } : null;

  useEffect(() => {
    if (!autoplay) setShowIcon(true);
    if (!rootEl.current || !videoOptions && !videoOptionsMobile) return;
    if (videoEl.current) {
      const player = videoEl.current.player;
      if (player) {
        player.on('play', () => {
          setIsPlaying(true);
          setShowIcon(false);
        });
        player.on('pause', () => {
          setIsPlaying(false);
          setShowIcon(true);
        });
        player.on('ended', () => {
          setIsPlaying(false);
          setShowIcon(true);
        });
      }

      const ScrollMagic = loadScrollMagic();
      if (!ScrollMagic) {
        return;
      }

      const controller = new ScrollMagic.Controller();
      const scene = new ScrollMagic.Scene({
        triggerElement: rootEl.current,
        triggerHook: 0.5,
        reverse: false
      })
        .on("enter", () => {
          if (!hasPlayedPreview.current && autoplay) {
            initAndPlayPreview();
          }
        })
        .addTo(controller);

      const initAndPlayPreview = () => {
        const currentOptions = isMobile ? videoOptionsMobile : videoOptions;
        if (!currentOptions?.sources?.length) return;
        if (!videoEl.current) return;
        if (player) {
          player.play();
          setIsPlaying(true);
          player.play().then(() => {
            const randomTime = Math.floor(Math.random() * 3) + 3;
            autoPlayTimer.current = setTimeout(() => {
              player.pause();
              setIsPlaying(false);
              setShowIcon(true);
              hasPlayedPreview.current = true;
            }, randomTime * 1000);
          })
        }
      };
      return () => {
        controller.destroy();
        if (autoPlayTimer.current) {
          clearTimeout(autoPlayTimer.current);
        }
      };
    }
  }, [video?.value?.src, m_video?.value?.src, isMobile]);

  const handlePlayClick = (e) => {
    e.stopPropagation();
    if (videoEl.current && videoEl.current.player) {
      videoEl.current.player.play();
      setIsPlaying(true);
      setShowIcon(false);
    }
  };
  const handleVideoClick = (e) => {
    e.stopPropagation();
    if (videoEl.current && videoEl.current.player) {
      videoEl.current.player.pause();
      setIsPlaying(false);
      setShowIcon(true);
    }
  };
  const mousemove = (e) => {
    if (isMobile) return;
    if (showIcon && rootEl.current && autoplay) {
      const rect = rootEl.current.getBoundingClientRect();
      const x = Math.max(0, Math.min(e.clientX - rect.left - 25, rect.width - 50));
      const y = Math.max(0, Math.min(e.clientY - rect.top - 25, rect.height - 50));
      setIconPosition({ top: y, left: x });
    }
  }
  const mouseLeave = (e) => {
    if (isMobile) return;
    if (autoplay) setShowIcon(false)
  }
  const mouseOver = (e) => {
    if (isMobile) return;
    if (!isPlaying && autoplay) {
      setShowIcon(true)
    }
  }
  const rootClasses = classNames("single-video", getOverallSettingsClasses(props.fields));
  return (
    <div className={rootClasses} datasourceid={props.rendering.dataSource}>
      <div className="single-video_content" ref={rootEl} onMouseMove={mousemove} onMouseLeave={mouseLeave} onMouseOver={mouseOver}>
        <div className="title" style={{ display: (!isMobile && isPlaying) ? 'none' : 'block' }}>
          <div>
            <Text tag="div" field={heading} />
          </div>
        </div>
        <div className="video-wrapper" onClick={handleVideoClick}>
          {showIcon &&
            <div className="video-play-btn" ref={playBtnNode} style={{ top: isMobile ? '50%' : iconPosition.top, left: isMobile ? '50%' : iconPosition.left, cursor: autoplay ? 'none' : 'pointer' }} onClick={handlePlayClick}>
              <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.1348 8.99988L0.932067 17.7772L0.932068 0.222596L16.1348 8.99988Z" fill="white" />
              </svg>
            </div>
          }
          {
            ((!isMobile && video && video.value) || (m_video && m_video.value && isMobile)) &&
            <Videojs {...isMobile ? videoOptionsMobile : videoOptions} id={'VideoPlay-singleVideoModel'} ref={videoEl} />
          }
        </div>
      </div>
    </div>
  )
};
export default SingleVideo;
